let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cQ2OK"), load("4gtMV"), load("c6MKV"), load("anGwD")]).then(() => parcelRequire('1nPts'));